import { create } from "zustand";
import { providerStore as defaultStore } from "./index";
import { DEFAULT_PROVIDER, PASSWORD_SALT, type ProviderSettings, type ProviderStore, type UsageEntry } from "./types";
import { sha256Hex } from "./password";

export interface ProviderState {
  settings: ProviderSettings; loaded: boolean; authed: boolean; store: ProviderStore;
  /** Sunucu sürümü: parola ekranı yok, yönetici rolü API'den. */
  serverMode: boolean;
  load(): Promise<void>;
  login(password: string): Promise<boolean>;
  logout(): void;
  update(patch: Partial<ProviderSettings> | ((s: ProviderSettings) => ProviderSettings)): Promise<void>;
  setPassword(password: string): Promise<void>;
  appendLog(e: Omit<UsageEntry, "at">): Promise<void>;
  clearLog(): Promise<void>;
  useStore(store: ProviderStore, serverMode?: boolean): void;
}

export const useProvider = create<ProviderState>((set, get) => ({
  settings: structuredClone(DEFAULT_PROVIDER), loaded: false, authed: false, store: defaultStore, serverMode: false,
  async load() {
    try { set({ settings: await get().store.get(), loaded: true }); }
    catch { set({ loaded: true }); } // sunucu ayarı okunamazsa varsayılanla devam
  },
  async login(password) {
    const s = get().loaded ? get().settings : await get().store.get();
    const ok = (await sha256Hex(PASSWORD_SALT + password)) === s.passwordHash;
    set({ authed: ok, settings: s, loaded: true });
    return ok;
  },
  logout() { set({ authed: false }); },
  async update(patch) {
    const next = typeof patch === "function" ? patch(get().settings) : { ...get().settings, ...patch };
    await get().store.set(next);
    set({ settings: next });
  },
  async setPassword(password) { await get().update({ passwordHash: await sha256Hex(PASSWORD_SALT + password) }); },
  async appendLog(e) {
    const entry: UsageEntry = { at: new Date().toISOString(), ...e };
    await get().store.appendLog(entry);
    set({ settings: await get().store.get() });
  },
  async clearLog() { await get().update({ usageLog: [] }); },
  useStore(store, serverMode = false) { set({ store, serverMode, loaded: false, authed: false, settings: structuredClone(DEFAULT_PROVIDER) }); },
}));
